export default __webpack_public_path__ + "static/media/win.70455fd4.mp3";